import {
  processUnitSetLabelAction,
  processUnitSetValueAction,
  processSetUnitsAction
} from '@r/reducers/utils';
import { inches, quantity } from 'decl/general/units';
import { UnitsInputv2Value } from 'decl/general/html';
import { AllActions } from '@r/storeUtils';

type tall = redux._IStore['projectFor3d']['cabinetsSettings']['tall'];
const tallDefault: tall = {
  depth: {
    value: 24 as inches,
    label: '' as UnitsInputv2Value
  },
  height: {
    value: 93 as inches,
    label: '' as UnitsInputv2Value
  },
  shelvesQty: 4 as quantity
};

export const tall = (
  state = tallDefault,
  action: AllActions
): typeof state => {
  switch( action.type ) {
    case 'SET_CABINETS_SETTINGS_TALL_DEPTH_LABEL': {
      return {
        ...state,
        depth: processUnitSetLabelAction( state.depth, action )
      };
    }
    case 'SET_CABINETS_SETTINGS_TALL_DEPTH_VALUE': {
      return {
        ...state,
        depth: processUnitSetValueAction( state.depth, action )
      };
    }
    case 'SET_CABINETS_SETTINGS_TALL_HEIGHT_LABEL': {
      return {
        ...state,
        height: processUnitSetLabelAction( state.height, action )
      };
    }
    case 'SET_CABINETS_SETTINGS_TALL_HEIGHT_VALUE': {
      return {
        ...state,
        height: processUnitSetValueAction( state.height, action )
      };
    }
    case 'SET_CABINETS_SETTINGS_TALL_SHELVES_QTY': {
      return {
        ...state,
        shelvesQty: action.value
      };
    }
    case 'SET_UNITS': {
      return {
        ...state,
        height: processSetUnitsAction( state.height, action ),
        depth: processSetUnitsAction( state.depth, action )
      };
    }
    default:
      return state;
  }
};
